import { ListItem } from '@silverfort/sf-components';

export interface MenuOption<T> {
    id: T;
    label: string;
}

interface Props<T> {
    options: MenuOption<T>[];
    selectedOptionId: T;
    onOptionClick: (id: T) => void;
}

const Menu = <T,>({ options, selectedOptionId, onOptionClick }: Props<T>) => (
    <div className="h-full w-50 border-e border-sf-gray-100">
        {options.map((option) => (
            <ListItem
                key={`${option.id}`}
                className="h-10 rounded-none border-b border-sf-gray-100 leading-[15.51px]"
                title={option.label}
                selected={option.id === selectedOptionId}
                onClick={() => onOptionClick(option.id)}
            />
        ))}
    </div>
);

export default Menu;
